export default {"src":"/_next/static/media/arrow-left-circle.a3d5569d.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};